import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    document.body.classList.add("overflow-hidden")
  }

  close() {
    // Remove the modal from DOM and restore scrolling
    document.body.classList.remove("overflow-hidden")
    this.element.remove()

    // Remove query param from URL without reload
    const url = new URL(window.location)
    url.searchParams.delete("show_assessment")
    window.history.replaceState({}, "", url)
  }

  stopPropagation(event) {
    event.stopPropagation()
  }
}
